import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const terraformCloud = defineConnector({
  identifier: "terraformCloud",
  name: "Terraform Cloud",
  tagLine: "Infrastructure as code",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://app\\.terraform\\.io/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Get your Terraform Cloud API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Terraform Cloud, go to **User Settings > Tokens** and create a new API token. For organization-level access, create a team or organization token instead.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://app.terraform.io/api/v2/account/details",
  },
});
